<template>
    <div>
        <file-manager-modal
            :value="show_file_manager_dialog"
            @updated="updateTable"
            @closeDialog="show_file_manager_dialog=false"
        />

        <div class="tw-flex tw-flex-col tw-gap-4 tw-p-1">
            <internal-table-section :section-title="titleFileManager" button-text="Add File" @button-clicked="addFile" class="tw-w-full">
                <v-card id="table_card" class="d-flex flex-row container-fluid" flat>
                    <v-card-text class="pa-0 d-block">
                        <v-layout child-flex>
                            <smart-table
                                id="filemanager_table"
                                endpoint="filemanagers.list"
                                :headers="headers"
                                :search="search"
                                ref="smartTable"
                                flat
                            >
                                <template
                                    v-slot:item.original_url="{ item }"
                                >
                                    <v-icon
                                        @click="copyURL(item)"
                                        title="Copy Link"
                                    >
                                        mdi-content-copy
                                    </v-icon>
                                    {{ item.original_url }}
                                </template>
                                <template
                                    v-slot:item.delete_action="{ item }"
                                >
                                    <v-icon
                                        @click.stop="deleteDue(item)">
                                        title="Delete File"
                                        >
                                        mdi-delete
                                    </v-icon>
                                </template>
                            </smart-table>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </internal-table-section>
        </div>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import SmartTable from "@/Generic/SmartTable";
import InternalHeader from "@/Generic/InternalHeader";
import InternalTableSection from "@/Generic/InternalTableSection";
import FileManagerModal from "@/Modals/FileManagerModal.vue";

export default {
    name: "WebsiteContentFileManager",
    layout: (h, page) => {
        return h(AppLayout, [
            page
        ])
    },
    components: {
        FileManagerModal,
        SmartTable,
        InternalHeader,
        InternalTableSection
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'valuelists': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        }
    },
    data() {
        return {
            titleFileManager: 'File Manager',
            search: null,
            filters: {
                id: undefined,
            },
            show_file_manager_dialog: false,
        }
    },
    computed: {
        headers() {
            return [
                {value: 'name',         text: 'Title',  align: `start`,  sortable: false,     filterable: false,   search: null  },
                {value: 'original_url', text: 'URL',    align: `start`,  sortable: false,     filterable: false,   search: null  },
                {value: 'delete_action',text: 'Delete', align: `end`,    sortable: false,     filterable: false,   search: null  },
            ]
        },
    },
    methods: {
        addFile() {
            this.show_file_manager_dialog = true
        },
        updateTable() {
            this.$refs.smartTable.refreshList()
        },
        copyURL(item) {
            navigator.clipboard.writeText(item.original_url)
                .then(() => {
                    this.$root.snackbar.success('Link Copied')
                })
                .catch(err => {
                    console.log(err);
                });

        },
        async deleteDue(item) {
            if (await this.$root.confirm.open(`Delete File?`, `You are about to delete this File, please make sure all references to it are removed.`)) {
                let method = 'delete'
                let url = route('filemanagers.destroy', item.id)
                let payload = item

                axios({
                    method: method,
                    url: url,
                    data: payload,
                    onUploadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('File has been deleted')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.archiveLoading = false
                            this.$refs.smartTable.refreshList()
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        this.$root.snackbar.error(error.response.data.message)
                        this.archiveLoading = false
                    })
            }
        },
    },
}
</script>

<style>
table tr td {
    border-bottom: 0 !important;
}

    .filters_search {
        min-width: 100px; max-width: 100%;
    }

    .filters_select {
        min-width: 100px; max-width: 200px;
    }

    .filters_button {
        min-width: 50px; max-width: 100px;
    }

    .bordered_up_top {
        border-top: 5px solid #4c4c4c !important;
    }
.bordered_up_top {
    border-top: 5px solid #4c4c4c !important;
}

.v-data-table__mobile-row {
    align-items: flex-start;
}

#filemanager_table > .v-data-table__wrapper > table > tbody > tr.v-data-table__mobile-table-row {
    border-top: solid;
    padding-top: 15px;
}

#filemanager_table .v-data-table__mobile-table-row {
    padding-bottom: 15px;
}

</style>
